import { post } from '@alltrails/shared/api';
import { components } from './schema';

type CouponResponse = components['schemas']['CouponResponse'];

// eslint-disable-next-line import/prefer-default-export
export async function verify(couponCode: string) {
  return post<CouponResponse>('/api/alltrails/coupons/verify', { coupon_code: couponCode });
}
